export default __webpack_public_path__ + "static/media/CNBC.4279eccf.svg";